// extracted by mini-css-extract-plugin
export default {"formContainer":"FurnitureEditor_formContainer__MjdaW"};